import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileuploadComponent } from './fileupload.component';
import { FileuploadService } from './fileupdate.service';

@NgModule({
  declarations: [ FileuploadComponent ],
  imports: [ CommonModule ],
  exports: [ FileuploadComponent ],
  providers: [ FileuploadService ],
})
export class FileuploadModule {}
